import { buildAppConfig, type AppConfig } from './app-config';
import type { Environment } from './models';

export function buildUiProfileConfig(
    environment: Environment,
    profile: string | undefined,
    productionFeatureFlags: Environment['featureFlags']
): AppConfig {
    if (profile && profile !== 'environment' && profile !== 'production') {
        throw new Error(`Unsupported NG_APP_UI_PROFILE: ${profile}`);
    }

    const useProductionUi =
        environment.env === 'production' || profile === 'production';

    return buildAppConfig(
        {
            ...environment,
            featureFlags: useProductionUi
                ? { ...productionFeatureFlags }
                : environment.featureFlags,
        },
        { useProductionUi }
    );
}
